export const reportBillingAction = {
  changeBillableDate: (state, action) => {
    const date = action.payload;
    state.billableDate = date;
  },
  changeOriginalBillableDate: (state, action) => {
    state.originalBillableDate = action.payload;
  },
  toggleBillingDate: (state, action) => {
    state.isBillingDateSubmitting = action.payload;
  },
};
